import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, MaterialIcon } from '@pearsontechnology/aero-components';

export const GreyButton = ({ iconName, ...rest }) => (
  <Button iconOnly grey height={34} {...rest}>
    <MaterialIcon id={iconName} />
  </Button>
);

GreyButton.propTypes = {
  iconName: PropTypes.string.isRequired,
};

export const SortButton = styled(
  ({ sort, id, ...rest }) => {
    let order = 'desc';
    if (id === sort.key) {
      order = sort.order;
    }
    return (<GreyButton iconName={order === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'} {...rest} />);
  },
)`
  margin-left: 5px;
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const SmallButton = styled(Button)`
  padding: 4px 10px;
  font-size: 12px;
  min-height: auto;
`;

export const StatusText = styled.span`
  color: ${(props) => (props.isDenied ? props.theme['color.redLight'] : 'inherit')};
`;

export const EmailPearsonIdColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PearsonIdLine = styled.span`
  display: block;
`;
